import React from 'react';
import { Image, Typography } from 'lib/components';
import { ErrorItem } from 'lib/components/types';
import { useHistory } from 'react-router';
import classes from './index.module.scss';

/**
 * Props interface for the ErrorScreen component
 */
interface Props {
	/** Error information object containing code, title, message, and optional icon */
	error: ErrorItem;
}

/**
 * ErrorScreen component
 * Displays a user-friendly error page with error code, title, and message
 * Provides a "Go Back" button to return to the previous page
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const ErrorScreen = ({ error }: Props) => {
	// Navigation helper for going back to previous page
	const { goBack } = useHistory();

	return (
		<div className={classes['error']}>
			<div className={classes['error-content']}>
				{/* Error information section */}
				<div className={classes['error-info']}>
					{/* Error icon - defaults to lock icon if not provided */}
					<Image src={error.icon ?? 'icErrorLock'} />
					{/* Error code (e.g., 403, 404, 500) */}
					<Typography className={classes['error-code']} variant="h1" color="primary" weight="bold">
						{error.code}
					</Typography>
					{/* Error title */}
					<Typography className={classes['error-title']}>{error.title}</Typography>
					{/* Error message with details */}
					<Typography>{error.message}</Typography>
				</div>
				{/* Go back button */}
				<a onClick={goBack} className={classes['error-goBack']}>
					<Typography color="primary">← Go Back</Typography>
				</a>
			</div>
		</div>
	);
};

export default ErrorScreen;
